<script lang="ts" setup>
import { useDocumentChecklist } from "@/stores/useDocumentChecklist";
import { jsxText } from "@babel/types";
import jsPDF from "jspdf";
import { storeToRefs } from "pinia";
import { VueFinalModal } from "vue-final-modal";
import html2canvas from "html2canvas";

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  revisionId: {
    type: String,
    required: true,
  },
});

defineEmits(["close"]);

// const loading = ref(true);

const store = useDocumentChecklist(props.documentId, props.revisionId)();

const { initialize, getCriteriaFromId } = store;

await initialize();

const { useChecklist, useTotalEarnedScore, useTotalScore } = storeToRefs(store);

if (!useChecklist.value) {
  throw new Error("Checklist is not defined");
}

const output = ref();

const generatePDF = async () => {
  if (!pdfSection.value) {
    return;
  }

  const checklist = useChecklist.value;

  if (!checklist) {
    return;
  }

  const pdf = new jsPDF({
    format: "letter",
    unit: "px",
  });

  pdf.html(pdfSection.value!, {
    callback: (doc) => {
      output.value = doc.output("datauristring");
      // doc.save(`${checklist.title}.pdf`);
    },
    autoPaging: "text",
    x: 8,
    y: 8,
    margin: [8, 0, 16, 0],
    // html2canvas: {
    //   // scale: 0.75,
    //   width: 800,
    //   windowWidth: 800,
    //   windowHeight: 1100,
    // },
  });
};

const pdfSection = ref<HTMLElement | null>(null);
</script>

<template>
  <VueFinalModal
    class="confirm-modal"
    content-class="confirm-modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <NuxtLayout name="dialog" @close="$emit('close')">
      <template #appBarActions>
        <BaseIconButton icon="fa-solid fa-file-arrow-down" @click="generatePDF">
        </BaseIconButton>
      </template>
      <div v-if="output" class="my-4 h-full w-full">
        <embed :src="output" class="w-full h-full" />
      </div>
      <div class="bg-white p-8 rounded">
        <div
          id="pdf-content"
          ref="pdfSection"
          class="max-w-[800px] w-full mx-auto"
        >
          <div class="bg-light-default p-4">
            <span class="text-h3 mb-2 block">
              {{ useChecklist?.title }}
            </span>
            <span class="text-h5">
              {{ useChecklist?.lessonName }}
            </span>
          </div>
          <div v-for="section in useChecklist?.sections ?? []" class="py-4">
            <span class="text-h5 font-bold px-4" style="line-height: unset">
              {{ section.title }}
            </span>
            <ul>
              <li
                v-for="criteria in section.criteriaInstances"
                class="p-2 px-4 flex flex-row justify-between items-start odd:bg-light-default text-body-1"
              >
                <span
                  >{{ getCriteriaFromId(criteria.checklistCriteriaId)?.label }}
                  and then I'm adding some really long text to make sure it all
                  wraps around properly.
                </span>
                <span class="ml-2">
                  <span>
                    {{ criteria.earnedPoints ?? 0 }}
                  </span>
                  <span v-if="criteria.maxPoints && criteria.maxPoints > 0">
                    <span class="mx-[2px]">/</span>
                    <span> {{ criteria.maxPoints ?? 0 }} </span>
                  </span>
                  <span class="ml-[2px]">pts</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="flex flex-row justify-end w-full px-4">
            <div class="flex flex-row font-bold">
              <span class="mr-4">Total:</span>
              <span>{{ useTotalEarnedScore }}</span>
              <span class="px-[2px]">/</span>
              <span>{{ useTotalScore }} pts</span>
            </div>
          </div>
        </div>
      </div>
    </NuxtLayout>
  </VueFinalModal>
</template>

<style>
.confirm-modal {
}
.confirm-modal-content {
  display: flex;
  flex-direction: column;

  width: 800px;
  height: 90%;
  margin: auto;
  @apply rounded;
}
</style>
